var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apiClientServices from "../api-client";
import { MEETING_ENDPOINTS } from "./endpoints";
/**
 * Best-effort create/renew of the Graph webhook subscription for this meeting.
 * Idempotent on the backend (renews if present, creates if not), so it is safe
 * to call every time Connect is opened. Never throws / never blocks the join.
 */
export const ensureMeetingSubscription = (meetingId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield apiClientServices({
            method: "POST",
            url: MEETING_ENDPOINTS.CREATE_MEETING_SUBSCRIPTION,
            data: {
                meetingId,
            },
        });
    }
    catch (error) {
        console.error("Failed to create/renew meeting subscription:", error);
    }
});
